module.exports = __webpack_public_path__ + "static/media/align-v-middle.a1dafeae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/align-v-middle.svg
// module id = 1181
// module chunks = 3